import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"row":""}},[_c(VFlex,{staticClass:"pl-4 pr-4 mt-3 mb-4"},[_c(VCard,[_c(VToolbar,{attrs:{"color":"grey","dark":""}},[_c(VToolbarTitle,[_vm._v("Usuarios")]),_c(VSpacer),_c(VBtn,{attrs:{"color":"blue","icon":""}},[_c(VIcon,[_vm._v("mdi-search")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }